/* eslint-disable @typescript-eslint/restrict-plus-operands */
import { reactive } from "vue";
import { Platform } from "./platform-provider";

interface GuideStep {
	text: string;
	image?: string;
	video?: string;
}

export interface Guide {
	title?: string;
	platform?: string;
	thumbnail?: string;
	level?: string;
	content?: Array<GuideStep>;
	description?: string;
}

export interface Guides {
	stories: Array<GuideModel>;
}

export interface GuideModel {
	name: string;
	id: number;
	content: GuideContentModel;
	slug: string;
}

export interface GuideContentModel {
	title: string;
	mode: string;
	description: string;
	image: StoryblokImage;
	video?: string;
}

interface StoryblokImage {
	filename: string;
}

class GlobalState {
	public platform: Platform | undefined;
	public language: string = "en";
	public filename: string | undefined = "Untitled Project";
	public assignmentModeActive: boolean = false;
	public assignmentViewModeActive: boolean = false;
	public isSearchOpen: boolean = false;
	public isSharedProject: boolean = false;
	public screenshotMode: boolean = false;
	public textOnlyMode: boolean = false;
	public showRaspberryPiModal: boolean = false;
	public currentProject: firebase.default.storage.Reference | undefined;
	public isFirebaseProject: boolean = false;
	public currentGuide: GuideModel | undefined;
	public usbDevice: USBDevice | undefined;
	public serialDevice: SerialPort | undefined;
	public currentGuideStep: number = 0;
}

export const state: GlobalState = reactive(new GlobalState);

/**
 * Format date to global format
 * @param {string|undefined} dateString
 * @returns string
 */
export function formatDate(dateString: string | undefined): string {
	let formattedDate: string = "";

	const today: Date = new Date();
	const yesterday: Date = new Date(today);
	yesterday.setDate(yesterday.getDate() -1);

	if (dateString) {
		const date: Date = new Date(dateString);

		if (date.toDateString() === today.toDateString()) {
			formattedDate = "Today at " + date.toLocaleTimeString().slice(0, -3);
		}

		else if (date.toDateString() === yesterday.toDateString()) {
			formattedDate = "Yesterday at " + date.toLocaleTimeString().slice(0, -3);
		}

		else {
			formattedDate = date.toLocaleString().slice(0, -3);
		}
	}

	return formattedDate;
}

export function getGradient(): string {
	const gradients: Array<string> = [
		"bg-gradient-to-r to-indigo-500 from-purple-500",
		"bg-gradient-to-r from-amber-300 to-orange-500",
		"bg-gradient-to-r from-green-400 to-cyan-500",
		"bg-gradient-to-r from-fuchsia-500 to-purple-600",
		"bg-gradient-to-r from-lightBlue-400 to-indigo-500",
		"bg-gradient-to-r from-orange-400 to-pink-600",
		"bg-gradient-to-r from-cyan-400 to-lightBlue-500"
	];

	return gradients[Math.floor(Math.random()*gradients.length)];
}

export function dragElement(elmnt: HTMLElement): void {
	let pos1: number = 0;
	let pos2: number = 0;
	let pos3: number = 0;
	let pos4: number = 0;
	if (document.getElementById(elmnt.id + "header")) {
	  // if present, the header is where you move the DIV from:
	  const header: HTMLElement = document.getElementById(elmnt.id + "header") as HTMLElement;
	  header.onmousedown = dragMouseDown;
	}
	else {
	  // otherwise, move the DIV from anywhere inside the DIV:
	  elmnt.onmousedown = dragMouseDown;
	}
  
	function dragMouseDown(e: any): void {
	  e = e || window.event;
	  e.preventDefault();
	  // get the mouse cursor position at startup:
	  pos3 = e.clientX;
	  pos4 = e.clientY;
	  document.onmouseup = closeDragElement;
	  // call a function whenever the cursor moves:
	  document.onmousemove = elementDrag;
	}
  
	function elementDrag(e: any): void {
	  e = e || window.event;
	  e.preventDefault();
	  // calculate the new cursor position:
	  pos1 = pos3 - e.clientX;
	  pos2 = pos4 - e.clientY;
	  pos3 = e.clientX;
	  pos4 = e.clientY;
	  // set the element's new position:
	  if (elmnt.offsetTop - pos2 > 0) {
	  	elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
	  }
	  if (elmnt.offsetLeft - pos1 > 0) {
	  	elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
	  }
	}
  
	function closeDragElement(): void {
	  // stop moving when mouse button is released:
	  document.onmouseup = null;
	  document.onmousemove = null;
	}
}